import React from 'react';
import {
  QuestionBaseContentData,
  QuestionChangeData,
  QuestionContent,
} from './QuestionContent';
import QuestionType, {
  getQuestionInstructions,
} from '@ax2/common/model/QuestionType';
import {
  Textarea,
  TextareaData,
} from 'components/question-builders/base/Textarea';
import { List, ListData } from './base/List';
import radioButtonIcon from '../../assets/radio_button_gray.svg';

export type RadioButtonListQuestionData = TextareaData &
  Omit<ListData, 'typeIcon'> &
  QuestionBaseContentData &
  QuestionChangeData;

export const RadioButtonListQuestion: React.FC<
  RadioButtonListQuestionData
> = props => {
  return (
    <QuestionContent
      {...props}
      questionContentElement={
        <Textarea
          {...props}
          info={getQuestionInstructions(props.question, true)}
        />
      }
      answerContentElement={<List {...props} typeIcon={radioButtonIcon} />}
      preselectedType={QuestionType.RadioButtonList}
    />
  );
};
